<template>
	<div class="activate" :class="{ 'ac-bg-gray': ac }">
		<header-component :is-soon="true" img-left="/trocachip/img/default_white.png"
			img-right="/trocachip/img/access-white.svg" class="header-component" v-if="!logoMobile" />
		<header-component :is-soon="true" img-left="/trocachip/img/logo.png" img-right="/trocachip/img/access-white.svg"
			class="header-component" v-if="logoMobile" />
		<div :class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"></div>

		<activate-tim-client v-if="isExOi() == 'false'" />
		<activate-ex-oi-client v-if="isExOi() == 'true'" />
		<!-- <div class="container">
			<div class="activate_icon-success">
				<img src="../assets/images/ic-check.svg" v-if="!ac" />
				<img src="../assets/images/ic-check-ac.svg" v-if="ac" />
			</div>
			<h2
				class="activate_title"
				:class="{ 'ac-color-yellow': ac }"
				v-html="title"
			></h2>
			<p class="activate_info" v-html="info"></p>
			<p class="activate_info" v-html="subInfo"></p>
			<span class="activate_protocol">
				{{ labelProtocol }} {{ protocol }}
			</span>
		</div> -->
	</div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent';
import ActivateTIMClient from '../components/ActivateTIMClient';
import ActivateExOiClient from '../components/ActivateExOiClient';
import { mapState } from 'vuex';
import trackEvent from '../services/trackEvent';
import { ReasonLabelName } from '@/core/reason';

export default {
	name: 'Activate',
	components: {
		HeaderComponent,
		"activate-tim-client": ActivateTIMClient,
		"activate-ex-oi-client": ActivateExOiClient
	},
	data() {
		return {
			title: '',
			info: '',
			subInfo: '',
			labelProtocol: '',
		};
	},
	async created() {
		// const config = this.config.pageSucess;
		// this.title = this.isExOi()
		// 	? config.clientExOi.title
		// 	: config.default.title;
		// this.info = this.isExOi() ? config.clientExOi.info : config.default.info;
		// this.subInfo = this.isExOi()
		// 	? config.clientExOi.subInfo
		// 	: config.default.subInfo;
		// this.labelProtocol = this.isExOi()
		// 	? config.clientExOi.protocolo
		// 	: config.default.protocolo;

		// if (this.protocol === '') return this.$router.push('/chip');
		this.sendCustomDimension('Protocolo_TC', this.protocol);
	},
	computed: {
		...mapState({
			ac: (state) => state.ac,
			document: (state) => state.document,
			pinToken: (state) => state.pinToken,
			config: (state) => state.config,
			customer: (state) => state.customer,
			protocol: (state) => state.protocol,
			reason: (state) => state.reason
		}),
		logoMobile: function () {
			return window.innerWidth < 768;
		},
	},
	mounted() {
		this.clientActivationEvent();
		this.planActivationEvent();


	},
	methods: {
		async sendCustomDimension(dimension, value) {
			// Convert value to string if it's not already
			const strValue = String(value);

			// Replace spaces, asterisks, and parentheses
			const sanitizedValue = strValue
				.replace(/\s/g, '_')    // Replace spaces with underscores
				.replace(/\*/g, '_')     // Remove asterisks
				.replace(/[()]/g, '_');  // Remove parentheses - no need to escape inside []
			console.log("Sending " + dimension + ": " + sanitizedValue);
			const command = `decibelInsight("sendCustomDimension", "${dimension}", "${sanitizedValue}");`;
console.log(command)
			window.eval(command);
		},
		clientActivationEvent() {
			trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: this.customer.loginType,
					lineType: this.customer.lineType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 7,
				'event-label': this.isExOi() ?
					'Troca de Chip Sucesso Cliente Oi' :
					`Troca de Chip Sucesso ${ReasonLabelName[this.reason] === "Mudança tecnologia" ? "Mudanca Tecnologia" : ReasonLabelName[this.reason]}`,
				'event-value': null,
				'event-status': 'Sucesso',
				'event-interactionNumber': this.protocol,
			});
		},
		planActivationEvent() {
			trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: this.customer.loginType,
					lineType: this.customer.lineType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 2,
				'event-label': `Troca de Chip - ${(this.customer.planDesc).normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`,
				'event-value': null,
				'event-status': 'Sucesso',
				'event-interactionNumber': this.protocol,
			});
		},
		isExOi() {
			return this.customer.isExOiCustomer;
		},
	},
};
</script>

<style lang="scss">
.activate {
	width: 100%;
	height: 100vh;
	display: block;
	position: fixed;
	background: #003091;
	overflow-y: auto;
	z-index: -1;

	>.container {
		>.activate_icon-success {
			width: 61px;
			height: 61px;
			margin: 104px auto 0 auto;
			position: relative;
			display: block;
		}

		>.activate_title {
			width: 292px;
			height: auto;
			display: block;
			position: relative;
			font-family: 'timsans_regular';
			margin: 40px auto 0 auto;
			font-size: 1.688em;
			font-weight: 300;
			line-height: 1.11;
			text-align: center;
			color: #ffffff;
		}

		>.activate_info {
			width: 252px;
			height: auto;
			display: block;
			position: relative;
			margin: 16px auto 0 auto;
			font-family: 'timsans_regular';
			font-size: 0.75em;
			line-height: 1.33;
			letter-spacing: -0.3px;
			text-align: center;
			color: #ffffff;
		}

		>.activate_protocol {
			width: 147px;
			height: auto;
			display: block;
			position: relative;
			margin: 138px auto 0 auto;
			font-family: 'timsans_regular';
			font-size: 0.75em;
			line-height: 2;
			text-align: center;
			color: #ffffff;
		}
	}
}

@media (min-width: 768px) {
	.activate {
		width: 100%;
		height: 100vh;
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'container background';
		position: absolute;
		background: #003091;
		overflow-y: auto;
		z-index: -1;

		.header-component {
			width: 45%;
			grid-area: header;
		}

		.background-desktop {
			grid-area: background;
			width: 100%;
			height: 100vh;
			display: block;
			background: url('../assets/images/desktop@3x.png') no-repeat;
			background-size: cover;
			background-position: -30px;
		}

		.background-desktop-black {
			grid-area: background;
			width: 100%;
			height: 100vh;
			display: block;
			background: url('../assets/images/desktop-black.png') no-repeat;
			background-size: cover;
			background-position: -30px;
		}

		>.container {
			grid-area: container;

			>.activate_icon-success {
				width: 61px;
				height: 61px;
				margin: 115px auto 0 auto;
				position: relative;
				display: block;
			}

			>.activate_title {
				width: 300px;
				height: auto;
				display: block;
				margin: 115px auto 0 auto;
				font-family: 'timsans_thin';
				font-size: 2em;
				font-weight: 300;
				line-height: 1.2;
			}

			>.activate_info {
				width: 300px;
				margin: 31px auto 0 auto;
				font-family: 'timsans_regular';
				font-size: 1em;
				line-height: 1.33;
				letter-spacing: -0.3px;
				text-align: center;
				color: #ffffff;
			}

			>.activate_protocol {
				width: 300px;
				margin: 73px auto 0 auto;
				font-family: 'timsans_regular';
				font-size: 1em;
				line-height: 2;
				text-align: center;
				color: #ffffff;
			}
		}
	}
}

@media (min-width: 1024px) {
	.activate {
		.background-desktop {
			background-position: 0;
		}

		.background-desktop-black {
			background-position: 0;
		}

		>.container {
			>.activate_title {
				width: 400px;
			}

			>.activate_info {
				width: 400px;
			}

			>.activate_protocol {
				width: 400px;
			}
		}
	}
}
</style>
